<template>
  <div class="coupon-issue-container">
    <div class="coupon-issue-header">发放优惠券</div>
    <div class="coupon-issue-desc">轻松创建和管理您的优惠券</div>
    <div class="select-lot" v-if="parkingOptionsCount <= 1">
      <input
        ref="lotSearchInput"
        :value="selectedLabel"
        class="lot-input"
        type="text"
        readonly
        autocomplete="off"
      />
    </div>
    <div class="select-lot" v-else @click="toggleDropdown">
      <input
        ref="lotSearchInput"
        :value="selectedLabel"
        class="lot-input"
        type="text"
        readonly
        autocomplete="off"
      />
      <div class="dropdown-panel" v-if="showDropdown">
        <div class="dropdown-list">
          <div
            v-for="opt in parkingOptions"
            :key="opt.value"
            class="dropdown-item"
            @click.stop="selectOption(opt)"
          >
            <span class="tag parking">停车场</span>
            <span class="label">{{ opt.label }}</span>
          </div>
          <div v-if="parkingOptions.length === 0" class="dropdown-empty">暂无停车场</div>
        </div>
      </div>
    </div>
    <div class="coupon-issue-tabs">
      <div :class="['coupon-issue-tab', active==='all' && 'active']" @click="active='all'">全部</div>
      <div :class="['coupon-issue-tab', active==='time' && 'active']" @click="active='time'">时长券</div>
      <div :class="['coupon-issue-tab', active==='cash' && 'active']" @click="active='cash'">金额券</div>
      <div :class="['coupon-issue-tab', active==='percent' && 'active']" @click="active='percent'">折扣券</div>
      <div :class="['coupon-issue-tab', active==='free' && 'active']" @click="active='free'">全免券</div>
    </div>
    <div class="coupon-issue-cards">
      <div v-if="display.length === 0" class="coupon-empty-tip">
        <div class="empty-tip-icon">🎫</div>
        <div class="empty-tip-text">暂无优惠券</div>
        <div class="empty-tip-desc">该商户暂无可用的优惠券</div>
      </div>
      <div v-for="(c,i) in display" :key="i" :class="['coupon-issue-card', selected===i && 'selected']" @click="selected=i" :style="c.bg">
        <div class="coupon-issue-card-title">{{ c.title }}</div>
        <div class="coupon-issue-card-value">{{ c.value }}</div>
        <div class="coupon-issue-card-date">{{ c.date }}</div>
      </div>
    </div>
    <!-- 优惠券分页：加载更多 / 没有更多 -->
    <div v-if="shouldShowLoadMoreCoupon" class="load-more-container">
      <button class="load-more-btn" :disabled="couponLoading" @click="loadMoreCoupons">
        {{ couponLoading ? '加载中...' : '加载更多' }}
      </button>
    </div>
    <div v-if="shouldShowNoMoreCoupon" class="load-more-container">
      <div class="no-more-text">没有更多了</div>
    </div>
    <div class="coupon-issue-action-card">
      <div v-if="isAllowCustomCoupon" class="coupon-issue-action-row" style="margin-bottom:6px;">
        <button class="coupon-issue-action-btn coupon-issue-action-btn-blue" @click="goToCreate">＋自定义创建</button>
      </div>
      <div class="coupon-issue-action-row">
        <button class="coupon-issue-action-btn" @click="qrcode">生成二维码</button>
      </div>
      <div class="coupon-issue-action-row">
        <input 
          type="text" 
          class="coupon-issue-action-input" 
          :value="plate" 
          @click="openPlateKeyboard"
          placeholder="请输入车牌"
          readonly
        >
        <button class="coupon-issue-action-search">搜索</button>
      </div>
      <div class="coupon-issue-action-row">
        <button class="coupon-issue-action-btn coupon-issue-action-btn-blue" style="width:100px;" @click="issue">确认发放</button>
      </div>
    </div>
    <BottomNav />
    <!-- 车牌输入键盘 -->
    <PlateKeyboard
      :visible="plateKeyboardVisible"
      :value="plate"
      :maxLength="8"
      @input="handlePlateKeyboardInput"
      @close="closePlateKeyboard"
    />
    <!-- 精致二维码弹窗 -->
    <div v-if="qrVisible" class="qr-modal" @click.self="closeQRCode">
      <div class="qr-dialog">
        <!-- 关闭按钮（右上角） -->
        <button class="qr-close-btn" @click="closeQRCode">×</button>
        <!-- 二维码容器（带边框和阴影） -->
        <div class="qr-image-container" :class="{ 'qr-image-grayed': isQRCodeGrayed, 'has-merged-image': mergedQrCodeImageUrl }">
          <img v-if="mergedQrCodeImageUrl" :src="mergedQrCodeImageUrl" alt="qr" class="qr-img merged-image" />
          <img v-else-if="qrImgUrl" :src="qrImgUrl" alt="qr" class="qr-img" />
          <div v-else class="qr-loading">
            <div>正在生成二维码...</div>
          </div>
          <!-- 灰色遮罩（当刷新100次后code未变化时显示） -->
          <div v-if="isQRCodeGrayed && !mergedQrCodeImageUrl" class="qr-gray-overlay">
            <div class="qr-gray-text">二维码已暂停刷新<br/>点击下方按钮恢复</div>
          </div>
        </div>
        <!-- 优惠券类型 + 当前时间 -->
        <div class="qr-info">
          <div class="qr-coupon-type">{{ currentQRCodeCouponType || '优惠券' }}</div>
          <div class="qr-time">{{ currentTime }}</div>
        </div>
        <!-- 刷新进度条（已隐藏，但定时刷新功能保留） -->
        <div v-if="false" class="qr-refresh-progress">
          <div class="qr-progress-bar" :style="{ width: refreshProgress + '%' }"></div>
        </div>
        <!-- 操作按钮区域 -->
        <div class="qr-actions">
          <!-- 圆形滚动刷新按钮（仅动态二维码显示） -->
          <div v-if="!isStaticQrCode" class="qr-refresh-button-wrapper">
            <button 
              class="qr-refresh-button" 
              :class="{ 'qr-refresh-button-rotating': isRefreshing }"
              @click="manualRefreshQRCode"
              :disabled="isRefreshing"
            >
              <svg class="qr-refresh-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
              </svg>
            </button>
          </div>
          <!-- 更新按钮（静态二维码显示，用于更新版本号） -->
          <div v-if="isStaticQrCode" class="qr-update-button-wrapper">
            <button 
              class="qr-update-button" 
              :class="{ 'qr-update-button-loading': isUpdatingQRCode }"
              @click="handleUpdateQRCode"
              :disabled="isUpdatingQRCode"
            >
              <svg v-if="!isUpdatingQRCode" class="qr-update-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
              </svg>
              <span v-if="isUpdatingQRCode" class="qr-update-loading">更新中...</span>
              <span v-else>更新</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- 更新版本号确认弹窗 -->
    <div v-if="updateVersionModalVisible" class="update-version-modal" @click.self="closeUpdateVersionModal">
      <div class="update-version-dialog">
        <div class="update-version-header">
          <h3>更新静态二维码</h3>
          <button class="update-version-close-btn" @click="closeUpdateVersionModal">×</button>
        </div>
        <div class="update-version-body">
          <div class="update-version-info">
            <div class="version-label">当前版本号：</div>
            <div class="version-value">{{ currentVersionForUpdate || '未获取' }}</div>
          </div>
          <div class="update-version-input-wrapper">
            <label class="update-version-input-label">请输入当前版本号以确认更新：</label>
            <input
              v-model="inputVersionForUpdate"
              type="text"
              class="update-version-input"
              placeholder="请输入当前版本号"
              @keyup.enter="confirmUpdateQRCode"
            />
          </div>
        </div>
        <div class="update-version-footer">
          <button class="update-version-btn update-version-btn-cancel" @click="closeUpdateVersionModal">取消</button>
          <button class="update-version-btn update-version-btn-confirm" @click="confirmUpdateQRCode" :disabled="isUpdatingQRCode">
            {{ isUpdatingQRCode ? '更新中...' : '确定' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BottomNav from '@/components/BottomNav.vue'
import PlateKeyboard from '@/components/PlateKeyboard.vue'
import { getCouponListWithPage, dispatchCoupon, getCouponDetail, refreshCouponCode, invalidateCouponCode, getCurrentQrVersion, rotateCouponQr } from '@/api/coupon'
import { getMyBusinessDetail, getBusinessByUser } from '@/api/business'
import request from '@/utils/request'
import QRCode from 'qrcode'

export default {
  name: 'CouponPage',
  components: { BottomNav, PlateKeyboard },
  data () {
    return {
      active: 'all',
      selected: null,
      plate: '',
      plateKeyboardVisible: false,
      qrVisible: false,
      qrLink: '',
      qrImgUrl: '',
      currentQRCodeCouponId: null, // 当前二维码对应的优惠券ID
      currentQRCodeBusinessId: null, // 当前二维码对应的商户ID
      currentQRCodeMerchantName: '', // 当前二维码对应的商家名称
      currentQRCodeCouponType: '', // 当前二维码对应的优惠券类型
      currentTime: '', // 当前时间（yyyy-mm-dd hh:mm:ss格式）
      currentQRCode: '', // 当前二维码的 code
      currentQRCodeRecord: {}, // 当前二维码对应的优惠券详情信息（用于合成图片）
      mergedQrCodeImageUrl: '', // 合成后的图片URL（包含底色、优惠券信息和二维码）
      qrVersionCache: {}, // 二维码版本号缓存，key为couponId_businessId，value为版本号
      qrRefreshTimer: null, // 二维码刷新定时器
      timeUpdateTimer: null, // 时间更新定时器
      progressInterval: null, // 进度条动画定时器
      isStaticQrCode: true, // 是否是静态二维码
      refreshProgress: 0, // 刷新进度（0-100）
      isRefreshing: false, // 是否正在手动刷新
      refreshCount: 0, // 刷新计数器（当code未变化时累加）
      isQRCodeGrayed: false, // 二维码是否被灰化（刷新100次后code未变化时）
      isUpdatingQRCode: false, // 是否正在更新二维码
      updateVersionModalVisible: false, // 更新版本号确认弹窗是否显示
      currentVersionForUpdate: '', // 当前版本号（用于显示在弹窗中）
      inputVersionForUpdate: '', // 用户输入的版本号
      loading: false,
      list: [],
      rawList: [], // 保存原始优惠券数据，用于发放时获取ID等信息
      // 分页（优惠券列表）
      couponPageNo: 1,
      couponPageSize: 10,
      couponTotal: 0,
      couponHasMore: false,
      couponLoading: false,
      // 是否使用真实API，默认使用后端API
      useRealAPI: process.env.VUE_APP_USE_REAL_API !== 'false',
      // 下拉选择相关
      showDropdown: false,
      searchKeyword: '',
      selectedLabel: '',
      options: [], // { type: 'parking'|'road', value: id, label: name-address }
      currentSelectedOption: null,
      // 商户信息
      merchants: [],
      currentBusinessId: null,
      isAllowCustomCoupon: false // 是否允许自定义创建优惠券
    }
  },
  computed: {
    display () {
      if (this.active === 'all') return this.list
      return this.list.filter(i => i.type === this.active)
    },
    filteredOptions () {
      const kw = (this.searchKeyword || '').trim().toLowerCase()
      if (!kw) return this.options
      return this.options.filter(o => o.label.toLowerCase().includes(kw))
    },
    parkingOptions () {
      // 只返回停车场类型的选项
      return Array.isArray(this.options) ? this.options.filter(opt => opt.type === 'parking') : []
    },
    parkingOptionsCount () {
      // 停车场选项的数量
      return this.parkingOptions.length
    },
    // 优惠券“加载更多”按钮显示条件
    shouldShowLoadMoreCoupon () {
      return this.couponHasMore && !this.couponLoading && this.display.length > 0
    },
    // 优惠券“没有更多了”显示条件
    shouldShowNoMoreCoupon () {
      return !this.couponHasMore && !this.couponLoading && this.display.length > 0
    }
  },
  async mounted () {
    // 页面加载前检查商户状态
    await this.checkBusinessStatus()
    // 先加载选项，然后由 selectOption 自动触发 loadCoupons（如果有选项）
    // 如果没有选项或选择失败，不应该调用 loadCoupons（因为没有筛选条件）
    await this.fetchScopeOptions()
    
    // 如果 fetchScopeOptions 成功并选择了第一个停车场，selectOption 会自动触发 loadCoupons
    // 如果没有选择（比如没有停车场选项），不应该调用 loadCoupons（因为没有筛选条件）
    // 只有在有选择的情况下，loadCoupons 才会被调用（由 selectOption 触发）
    // 如果 fetchScopeOptions 失败或没有选项，currentSelectedOption 为 null，不应该调用接口
    
    // 添加点击外部关闭下拉框的事件监听
    document.addEventListener('click', this.handleOutsideClick)
  },
  async activated () {
    // 页面激活前检查商户状态
    await this.checkBusinessStatus()
    // 如果使用了 keep-alive，页面激活时重新加载数据
    // 先等待 fetchScopeOptions 完成，确保 currentSelectedOption 已设置
    // 然后由 selectOption 自动触发 loadCoupons（如果有新选项并成功选择）
    // 如果没有新选项或选择失败，手动调用 loadCoupons 刷新数据
    const hadSelectionBefore = !!this.currentSelectedOption
    await this.fetchScopeOptions()
    
    // 检查 fetchScopeOptions 是否成功选择了选项
    // 如果 fetchScopeOptions 成功并调用了 selectOption(parkingOptions[0])，
    // selectOption 会自动触发 loadCoupons()，这里不需要再手动调用
    // 只有在以下情况才需要手动调用 loadCoupons()：
    // 1. 保留了原有的选择（hadSelectionBefore 为 true）- 需要刷新数据，但确保有筛选条件
    // 2. 有选项但没有自动选择（currentSelectedOption 为 null 且 options.length > 0）- 这种情况不应该调用，因为没选择
    
    // 只有在保留了原有选择的情况下才需要刷新数据
    // 如果自动选择了新选项，selectOption 已经触发了 loadCoupons
    // 如果没有选择（currentSelectedOption 为 null），不应该调用 loadCoupons（因为没有筛选条件）
    if (hadSelectionBefore && this.currentSelectedOption) {
      // 保留了原有选择，需要刷新数据
      this.loadCoupons()
    }
  },
  beforeUnmount () {
    // 清理定时器
    if (this.stopQRCodeRefreshTimer) {
      this.stopQRCodeRefreshTimer()
    }
    if (this.stopTimeUpdateTimer) {
      this.stopTimeUpdateTimer()
    }
    // 移除事件监听
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    async checkBusinessStatus () {
      // 检查商户是否被停用
      try {
        // 获取用户ID
        let userId = localStorage.getItem('userId')
        if (!userId) {
          const token = localStorage.getItem('token')
          if (token) {
            try {
              const parts = token.split('.')
              if (parts.length === 3) {
                const payload = JSON.parse(atob(parts[1]))
                userId = payload.userId || payload.uid || payload.sub || null
              }
            } catch (e) { /* ignore */ }
          }
        }
        
        if (!userId) {
          console.warn('[Coupon] 无法获取用户ID，跳过商户状态检查')
          return
        }
        
        console.log('[Coupon] 检查商户状态，用户ID:', userId)
        
        // 获取商户信息
        const businessResp = await getBusinessByUser(userId)
        const business = businessResp?.data || businessResp
        
        console.log('[Coupon] 商户信息:', business)
        
        // 检查商户是否被停用
        if (business && (business.isDisabled === true || business.is_disabled === true)) {
          console.error('[Coupon] 商户已被停用，阻止访问页面')
          
          // 清除token和用户信息
          this.$store.commit('CLEAR_USER')
          this.$store.commit('SET_TOKEN', '')
          localStorage.removeItem('token')
          localStorage.removeItem('userInfo')
          localStorage.removeItem('userId')
          sessionStorage.removeItem('wx_open_id')
          
          // 提示用户并跳转到登录页
          alert('您的账号对应的商户已被停用，无法访问。请联系管理员。')
          this.$router.replace('/login')
          return
        }
        
        console.log('[Coupon] 商户状态正常')
      } catch (e) {
        console.warn('[Coupon] 检查商户状态失败（不影响页面加载）:', e)
        // 如果检查失败，为了安全起见，可以选择阻止访问或继续
        // 这里选择继续，因为可能是网络问题等临时错误
      }
    },
    async loadCoupons (opts = {}) {
      const { pageNo = 1, append = false } = opts || {}
      // 避免并发加载
      if (this.couponLoading) return

      this.loading = true
      this.couponLoading = true
      
      if (this.useRealAPI) {
        // 使用真实API
        try {
          // 先尝试获取有效的token
          const token = await this.getValidToken()
          if (!token) {
            // token无效或不存在，提示用户重新登录
            console.warn('无法获取有效token，登录已过期')
            alert('登录已过期，请重新登录')
            // 跳转到登录页
            this.$router.push('/login')
            this.loading = false
            return
          }
          
          // 构建查询参数
          const params = {}
          
          // 优先使用在范围加载时获取并保存的商户ID
          const businessId = this.currentBusinessId
          
          // 如果选择了停车场/道路，添加相应的筛选条件
          if (this.currentSelectedOption) {
            if (this.currentSelectedOption.type === 'road') {
              params.roadId = this.currentSelectedOption.value
            }
          }
          // 传入当前商户ID，由后端按 businessId 过滤
          if (businessId) params.businessId = businessId
          
          // 检查是否有筛选条件，如果没有筛选条件，不应该调用接口获取全部数据
          const hasFilter = params.roadId || params.businessId
          
          if (!hasFilter) {
            console.warn('没有筛选条件（既没有选择停车场/道路，也没有商户ID），不调用接口，返回空列表')
            this.list = []
            this.rawList = []
            this.couponTotal = 0
            this.couponHasMore = false
            this.couponPageNo = 1
            this.loading = false
            this.couponLoading = false
            return
          }
          
          // 分页查询
          const resp = await getCouponListWithPage({
            pageNo,
            pageSize: this.couponPageSize,
            ...params
          })
          // MyApiResponse<List<CouponDTO>>：resp.data 为数组
          const rows = resp?.data || resp?.rows || []
          
          console.log('=== 优惠券筛选调试 ===')
          console.log('原始优惠券数据:', rows)
          console.log('传入businessId:', businessId)
          console.log('传入isDisabled:', params.isDisabled)
          
          // 在前端再次过滤：确保只显示未删除且未停用的优惠券
          // 过滤掉 isDeleted === true 或 isDisabled === true 的优惠券
          const filteredRows = rows.filter(row => {
            // 排除已删除的优惠券
            if (row.isDeleted === true) {
              return false
            }
            // 排除已停用的优惠券
            if (row.isDisabled === true) {
              return false
            }
            // 排除“已过期 / 未生效”的优惠券（严格按后端返回的具体开始/结束时间与当前时间判断）
            // 兼容字段：couponValidityDurationStart/End 以及少量可能的别名
            try {
              const now = new Date()
              const startRaw =
                row.couponValidityDurationStart ||
                row.validityStartTime ||
                row.validStartTime ||
                row.startTime ||
                null
              const endRaw =
                row.couponValidityDurationEnd ||
                row.validityEndTime ||
                row.validEndTime ||
                row.endTime ||
                null

              const parseDate = (v) => {
                if (!v) return null
                const d = new Date(v)
                if (isNaN(d.getTime())) return null
                return d
              }

              const startAt = parseDate(startRaw)
              const endAt = parseDate(endRaw)

              // 有结束时间且已过期：不展示
              if (endAt && endAt.getTime() < now.getTime()) {
                return false
              }
              // 有开始时间且未开始：不展示（避免展示“未生效”的券）
              if (startAt && startAt.getTime() > now.getTime()) {
                return false
              }
            } catch (e) { /* ignore */ }
            return true
          })
          
          // 保存原始数据（已过滤），用于发放时获取ID等信息
          if (append) {
            this.rawList = [...this.rawList, ...filteredRows]
            this.list = [...this.list, ...filteredRows.map(r => this.mapToCard(r))]
          } else {
            this.rawList = filteredRows
            // 由后端完成全部筛选，这里仅做展示映射
            this.list = filteredRows.map(r => this.mapToCard(r))
            this.selected = null
          }

          this.couponPageNo = pageNo
          // 判断是否还有更多：
          // 后端不按 isDisabled 过滤，所以前端过滤会导致“本页过滤后条数 < pageSize”并不代表没有更多。
          // 因此这里用“后端原始返回 rows.length >= pageSize”作为是否可能还有下一页的判断。
          this.couponHasMore = Array.isArray(rows) && rows.length >= this.couponPageSize

          // 如果筛选后没有优惠券，显示空状态
          if (this.list.length === 0) {
            console.log('筛选后没有优惠券数据')
            this.list = []
            this.rawList = []
            this.couponHasMore = false
            this.couponTotal = 0
          } else {
            console.log('成功从后端获取优惠券数据:', this.list)
          }
        } catch (e) {
          console.error('加载优惠券失败:', e)
          if (e.response?.status === 401) {
            console.warn('API访问被拒绝(401)，认证失败')
            // 401错误表示token无效，清除token并引导重新登录
            this.clearUserToken()
            alert('登录已过期，请重新登录')
            this.$router.push('/login')
          } else if (e.response?.status === 403) {
            console.warn('API访问被拒绝(403)，权限不足')
          } else if (e.response?.status >= 500) {
            console.warn('服务器错误(5xx)')
          } else {
            console.warn('网络或其他错误')
          }
          // 失败时显示空列表，而不是假数据
          this.list = []
          this.rawList = []
          this.couponTotal = 0
          this.couponHasMore = false
        }
      } else {
        // 使用模拟数据
        console.log('使用模拟数据模式')
        await new Promise(resolve => setTimeout(resolve, 500)) // 模拟网络延迟
        if (this.currentSelectedOption) {
          const mockData = this.getMockData()
          this.list = mockData
          // 模拟原始数据，用于发放功能（在模拟模式下无法真正发放）
          this.rawList = mockData.map((item, index) => ({
            couponId: `mock-coupon-${index}`,
            id: `mock-coupon-${index}`,
            businessId: 'mock-business-id',
            ...item
          }))
        } else {
          // 如果没有选择任何停车场/道路，显示空列表
          this.list = []
          this.rawList = []
        }
      }
      
      this.loading = false
      this.couponLoading = false
    },
    async loadMoreCoupons () {
      if (this.couponLoading || !this.couponHasMore) return
      const nextPage = (Number(this.couponPageNo) || 1) + 1
      await this.loadCoupons({ pageNo: nextPage, append: true })
    },
    async getValidToken () {
      try {
        // 优先从Vuex store获取token，如果没有则从localStorage获取
        // 这样可以避免某些情况下localStorage未同步成功的问题
        const storeToken = this.$store.getters.token
        const localStorageToken = localStorage.getItem('token')
        const existingToken = storeToken || localStorageToken
        
        if (existingToken) {
          // 验证token是否有效
          const isValid = await this.validateExistingToken(existingToken)
          if (isValid) {
            // 如果store中有token但localStorage中没有，同步到localStorage
            if (storeToken && !localStorageToken) {
              try {
                localStorage.setItem('token', storeToken)
              } catch (e) {
                console.warn('同步token到localStorage失败:', e)
              }
            }
            return existingToken
          } else {
            console.warn('本地token格式无效，无法使用')
            // token格式无效时，清除token和用户信息
            this.clearUserToken()
            return null
          }
        }
        
        // 如果没有token，返回null
        console.warn('未找到用户token，需要重新登录')
        return null
      } catch (e) {
        console.error('获取token失败:', e)
        // 发生错误时，清除token和用户信息
        this.clearUserToken()
        return null
      }
    },
    // 清除用户token和相关信息
    clearUserToken () {
      try {
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
        localStorage.removeItem('userId')
        // 清除Vuex中的用户信息
        this.$store.commit('CLEAR_USER')
        console.log('已清除用户token和相关信息')
      } catch (e) {
        console.error('清除用户信息失败:', e)
      }
    },
    async validateExistingToken (token) {
      try {
        // 只做最基本的检查：token是否存在且是字符串
        // 不检查token格式或是否过期，让后端API来判断
        // 这样可以避免：
        // 1. 前端时间不准确导致的误判
        // 2. token格式解析失败（某些token可能不是标准JWT）
        // 3. base64解码问题
        if (!token || typeof token !== 'string' || token.trim().length === 0) {
          if (process.env.NODE_ENV === 'development') {
            console.warn('[validateToken] token为空或不是有效字符串')
          }
          return false
        }
        
        // 如果token存在且是字符串，就认为有效
        // 让后端API来判断token是否真的有效
        if (process.env.NODE_ENV === 'development') {
          console.log('[validateToken] token存在，允许使用，由后端API验证有效性')
        }
        return true
      } catch (e) {
        if (process.env.NODE_ENV === 'development') {
          console.error('[validateToken] token验证异常:', e)
        }
        return false
      }
    },
    getMockData () {
      return [
        { title: '代金券', value: '¥50', date: '有效期至2024.12.31', type: 'cash', bg: 'background:linear-gradient(135deg,#ffb347,#ffcc33);' },
        { title: '时长券', value: '2小时', date: '有效期至2024.12.31', type: 'time', bg: 'background:linear-gradient(135deg,#4ca1ff,#70e1f5);' },
        { title: '全免券', value: '全免', date: '有效期至2024.12.31', type: 'free', bg: 'background:linear-gradient(135deg,#43e97b,#38f9d7);' }
      ]
    },
    mapToCard (row) {
      // 后端返回的类型（示例）：
      // TIME(时长券) / CASH(金额券) / PERCENT(折扣券) / FREE(全免券)
      const typeMapBg = {
        cash: 'background:linear-gradient(135deg,#ffb347,#ffcc33);',
        time: 'background:linear-gradient(135deg,#4ca1ff,#70e1f5);',
        free: 'background:linear-gradient(135deg,#43e97b,#38f9d7);',
        percent: 'background:linear-gradient(135deg,#fa709a,#fee140);'
      }
      const lower = this.normalizeType(row.couponType)
      
      // 根据优惠券类型获取正确的金额值
      let amount = null
      if (lower === 'cash') {
        // 优先使用 couponPriceYuan（元），如果不存在则使用 couponPrice（分）并转换为元
        if (row.couponPriceYuan !== undefined && row.couponPriceYuan !== null) {
          amount = row.couponPriceYuan
        } else if (row.couponPrice !== undefined && row.couponPrice !== null) {
          // couponPrice 是以"分"为单位，需要转换为"元"
          amount = row.couponPrice / 100
        } else {
          amount = row.discountAmount
        }
      } else if (lower === 'time') {
        amount = row.couponFreeMinutes || row.discountAmount
      } else if (lower === 'percent') {
        amount = row.couponDiscountRate || row.couponDiscountRatePercent || row.discountAmount
      }
      
      // 处理日期范围显示
      let dateRange = ''
      if (row.couponValidityDurationStart && row.couponValidityDurationEnd) {
        const startDate = this.formatDateForDisplay(row.couponValidityDurationStart)
        const endDate = this.formatDateForDisplay(row.couponValidityDurationEnd)
        dateRange = `${startDate} 至 ${endDate}`
      } else if (row.validityPeriod) {
        dateRange = row.validityPeriod
      } else if (row.couponValidityDurationStart) {
        dateRange = this.formatDateForDisplay(row.couponValidityDurationStart)
      }
      
      const card = {
        title: this.typeToTitle(lower),
        value: this.formatValue(lower, amount),
        date: dateRange,
        type: lower,
        bg: typeMapBg[lower] || typeMapBg.cash
      }
      
      return card
    },
    typeToTitle (t) {
      if (t === 'cash') return '金额券'
      if (t === 'time') return '时长券'
      if (t === 'free') return '全免券'
      if (t === 'percent') return '折扣券'
      return '优惠券'
    },
    normalizeType (backendType) {
      if (!backendType) return 'cash'
      const type = (backendType || '').toString().toUpperCase()
      if (type === 'TIME' || type === 'DURATION') return 'time'
      if (type === 'CASH' || type === 'AMOUNT' || type === 'MONEY') return 'cash'
      if (type === 'PERCENT' || type === 'DISCOUNT') return 'percent'
      if (type === 'FREE') return 'free'
      return 'cash'
    },
    formatValue (t, amount) {
      if (t === 'cash') {
        // 金额券：amount 已经是"元"为单位（在 mapToCard 中已处理）
        // 确保显示两位小数，并去除末尾的0
        const numAmount = Number(amount) || 0
        return `¥${numAmount.toFixed(2).replace(/\.?0+$/, '')}`
      }
      if (t === 'time') {
        // 时长券：处理分钟
        const minutes = parseInt(amount) || 0
        const hours = Math.floor(minutes / 60)
        const remainingMinutes = minutes % 60
        if (hours > 0) {
          return remainingMinutes > 0 ? `${hours}小时${remainingMinutes}分钟` : `${hours}小时`
        }
        return `${minutes}分钟`
      }
      if (t === 'free') return '全免'
      if (t === 'percent') {
        // 折扣券：处理百分比
        if (amount && amount > 1) {
          // 如果大于1，可能是百分比形式，转换为折扣
          return `${(amount / 10).toFixed(1)}折`
        }
        return `${amount || 0}折`
      }
      return amount || '未知'
    },
    // 格式化优惠面额文本（用于二维码 payload，与平台端格式保持一致）
    formatDiscountText (couponType, couponPriceYuan, couponDiscountRatePercent, couponFreeMinutes) {
      if (!couponType) return ''
      const type = (couponType || '').toString().toUpperCase()
      
      if (type === 'CASH' || type === 'AMOUNT' || type === 'MONEY') {
        // 金额券：couponPriceYuan 已经是"元"为单位（在调用时已处理）
        if (couponPriceYuan !== undefined && couponPriceYuan !== null) {
          const numAmount = Number(couponPriceYuan) || 0
          // 如果是整数，不显示小数；如果有小数，显示两位小数
          return numAmount % 1 === 0 ? `¥${numAmount}` : `¥${numAmount.toFixed(2)}`
        }
        return ''
      } else if (type === 'PERCENT' || type === 'DISCOUNT') {
        // 折扣券
        if (couponDiscountRatePercent !== undefined && couponDiscountRatePercent !== null) {
          // 如果大于10，可能是百分比形式，转换为折扣
          const rate = couponDiscountRatePercent > 10 ? (couponDiscountRatePercent / 10) : couponDiscountRatePercent
          return `${rate}折`
        }
        return ''
      } else if (type === 'TIME' || type === 'DURATION') {
        // 时长券
        if (couponFreeMinutes !== undefined && couponFreeMinutes !== null) {
          return `${couponFreeMinutes}分钟`
        }
        return ''
      } else if (type === 'FREE') {
        // 全免券
        return '全免'
      }
      return ''
    },
    formatDateForDisplay (dateString) {
      if (!dateString) return ''
      
      try {
        const date = new Date(dateString)
        if (isNaN(date.getTime())) return dateString
        
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        
        return `${year}-${month}-${day}`
      } catch (e) {
        console.warn('日期格式化失败:', dateString, e)
        return dateString
      }
    },
    async qrcode () {
      if (this.selected==null) return alert('请先选择一个优惠券')
      const selectedCoupon = this.rawList[this.selected]
      const couponId = selectedCoupon?.couponId || selectedCoupon?.id
      if (!couponId) return alert('优惠券ID缺失')
      let userId = localStorage.getItem('userId')
      if (!userId) {
        const token = localStorage.getItem('token')
        if (token) {
          try {
            const parts = token.split('.')
            if (parts.length === 3) {
              const payload = JSON.parse(atob(parts[1]))
              userId = payload.userId || payload.uid || payload.sub || null
            }
          } catch (e) { /* ignore */ }
        }
      }
      if (!userId) return alert('未找到用户ID')
      try {
        const merchantRes = await request({ url: '/market/business/list', method: 'post', data: { administor: userId }, timeout: 30000 })
        const merchantList = merchantRes?.data || []
        const businessId = merchantList?.[0]?.businessId
        if (!businessId) return alert('未找到商户信息')
        
        // 保存当前二维码的优惠券ID和商户ID，用于更新
        this.currentQRCodeCouponId = couponId
        this.currentQRCodeBusinessId = businessId
        
        // 保存商家名称和优惠券类型
        const merchantName = merchantList?.[0]?.businessName || merchantList?.[0]?.name || '商家'
        this.currentQRCodeMerchantName = merchantName
        const couponType = selectedCoupon?.couponType || ''
        this.currentQRCodeCouponType = this.formatCouponTypeText(couponType)
        
        // 第一步：获取商户信息，判断是否是静态二维码
        let isStaticQrCode = true // 默认为静态二维码
        try {
          const businessDetail = await getMyBusinessDetail(businessId)
          isStaticQrCode = businessDetail?.data?.isStaticQrCode !== false // 默认为true，只有明确为false时才设为false
          this.isStaticQrCode = isStaticQrCode
          console.log('商户二维码类型判断:', { businessId, isStaticQrCode })
        } catch (e) {
          console.warn('获取商户详情失败，使用默认值（静态二维码）:', e)
          this.isStaticQrCode = true
        }

        // 第二步：根据环境变量获取业务端URL
        const env = process.env.VUE_APP_ENV || process.env.NODE_ENV || 'development'
        let businessBaseUrl
        if (env === 'production') {
          businessBaseUrl = 'https://business.xihuiting.com'
        } else if (env === 'staging') {
          businessBaseUrl = 'https://testbusiness.xihuiting.com'
        } else {
          // 开发环境：使用 localhost
          const businessHost = process.env.VUE_APP_BUSINESS_HOST || 'localhost'
          const businessPort = process.env.VUE_APP_BUSINESS_PORT || '8019'
          businessBaseUrl = `http://${businessHost}:${businessPort}`
        }
        const base = `${businessBaseUrl}/#/coupon/qr`

        // 第三步：根据二维码类型生成URL
        let link
        if (isStaticQrCode) {
          // 静态二维码：获取版本号并添加到URL中
          // 每次打开二维码时都重新获取最新版本号，不使用缓存
          let version = ''
          const versionCacheKey = `${couponId}_${businessId}`
          
          // 清除缓存，强制从后端重新获取
          if (this.qrVersionCache[versionCacheKey]) {
            delete this.qrVersionCache[versionCacheKey]
            console.log('已清除版本号缓存，将从后端重新获取:', versionCacheKey)
          }
          
          // 从后端数据库获取当前版本号（不旋转）
          try {
            const currentVersionResp = await getCurrentQrVersion(businessId, couponId)
            // 兼容多种返回结构（request工具返回的是response.data）
            const resp = currentVersionResp || {}
            const d = resp.data
            version = (
              (resp.version) ||
              (d && d.version) ||
              (d && d.data && d.data.version) ||
              (d && typeof d === 'string' && d) ||
              (resp.result && resp.result.version) ||
              ''
            )
            // 如果获取到当前版本号，缓存它（性能优化）
            if (version) {
              this.qrVersionCache[versionCacheKey] = version
              console.log('静态二维码：获取到当前版本号', { businessId, couponId, version })
            } else {
              // 如果后端也没有版本号（说明是首次生成），调用 rotate 创建版本号并缓存
              console.log('静态二维码：未获取到版本号，尝试创建新版本号', { businessId, couponId })
              try {
                const rotateResp = await rotateCouponQr(businessId, couponId)
                // 兼容多种返回结构（request工具返回的是response.data）
                const rotateRespData = rotateResp || {}
                const rotateD = rotateRespData.data
                version = (
                  (rotateRespData.version) ||
                  (rotateD && rotateD.version) ||
                  (rotateD && rotateD.data && rotateD.data.version) ||
                  (rotateD && typeof rotateD === 'string' && rotateD) ||
                  (rotateRespData.result && rotateRespData.result.version) ||
                  ''
                )
                // 缓存版本号（性能优化）
                if (version) {
                  this.qrVersionCache[versionCacheKey] = version
                  console.log('静态二维码：成功创建新版本号', { businessId, couponId, version })
                } else {
                  console.error('静态二维码：创建版本号失败，返回值为空', { businessId, couponId, rotateResp })
                }
              } catch (rotateErr) {
                // 记录日志但不阻断，走降级
                console.error('静态二维码：创建二维码版本失败', { businessId, couponId, error: rotateErr })
              }
            }
          } catch (e) {
            // 获取当前版本号失败，尝试调用 rotate 创建版本号
            console.error('静态二维码：获取二维码版本失败，尝试创建新版本号', { businessId, couponId, error: e })
            try {
              const rotateResp = await rotateCouponQr(businessId, couponId)
              const rotateRespData = rotateResp || {}
              const rotateD = rotateRespData.data
              version = (
                (rotateD && rotateD.version) ||
                (rotateD && rotateD.data && rotateD.data.version) ||
                (rotateD && typeof rotateD === 'string' && rotateD) ||
                (rotateRespData.version) ||
                (rotateRespData.result && rotateRespData.result.version) ||
                ''
              )
              // 缓存版本号
              if (version) {
                this.qrVersionCache[versionCacheKey] = version
                console.log('静态二维码：成功创建新版本号（异常恢复）', { businessId, couponId, version })
              } else {
                console.error('静态二维码：创建版本号失败，返回值为空（异常恢复）', { businessId, couponId, rotateResp })
              }
            } catch (rotateErr) {
              // 记录日志但不阻断，走降级
              console.error('静态二维码：获取/创建二维码版本失败', { businessId, couponId, error: rotateErr })
              // 如果版本号获取/创建都失败，提示用户
              alert('生成二维码失败：无法获取版本号，请稍后重试')
              return
            }
          }
          
          // 静态二维码：必须包含 version 参数，否则无法验证
          if (!version) {
            console.error('静态二维码：版本号为空，无法生成有效二维码', { businessId, couponId })
            alert('生成二维码失败：无法获取版本号，请稍后重试')
            return
          }
          
          // 静态二维码：直接用 businessId 和 couponId 生成URL，不包含 code 参数，但必须包含 version 参数
          link = `${base}?bid=${encodeURIComponent(businessId)}&cid=${encodeURIComponent(couponId)}&version=${encodeURIComponent(version)}`
          this.currentQRCode = ''
          console.log('静态二维码：成功生成URL（包含version参数）', { businessId, couponId, version, link })
        } else {
          // 动态二维码：调用 refresh 接口获取 code，然后生成包含 code 的URL（不包含 version）
          try {
            console.log('动态二维码：调用 refresh 接口获取 code', { businessId, couponId })
            const codeResp = await refreshCouponCode(businessId, couponId)
            const code = codeResp?.data?.code || codeResp?.code
            if (code) {
              this.currentQRCode = code
              link = `${base}?bid=${encodeURIComponent(businessId)}&cid=${encodeURIComponent(couponId)}&code=${encodeURIComponent(code)}`
              console.log('动态二维码：已获取 code 并生成URL', { businessId, couponId, code })
            } else {
              console.warn('动态二维码：获取 code 失败，返回空值')
              this.currentQRCode = ''
              link = `${base}?bid=${encodeURIComponent(businessId)}&cid=${encodeURIComponent(couponId)}`
            }
          } catch (e) {
            console.error('动态二维码：调用 refresh 接口失败:', e)
            this.currentQRCode = ''
            // 即使获取code失败，也继续生成二维码（不带code参数）
            link = `${base}?bid=${encodeURIComponent(businessId)}&cid=${encodeURIComponent(couponId)}`
          }
        }

        this.qrLink = link
        // 使用 qrcode.js 本地生成二维码
        try {
          this.qrImgUrl = await QRCode.toDataURL(link, {
            width: 300,
            margin: 1,
            color: {
              dark: '#000000',
              light: '#FFFFFF'
            }
          })
          
          // 获取优惠券详情和停车场信息，用于合成图片
          try {
            const couponDetailResp = await getCouponDetail(couponId)
            const couponDetail = couponDetailResp?.data || {}
            
            // 获取停车场名称
            let parkingName = ''
            const parkIds = couponDetail.parkIds || selectedCoupon.parkIds || []
            if (parkIds.length > 0) {
              try {
                const uniqueParkIds = [...new Set(parkIds)]
                const parkingRes = await request({
                  url: '/parking/info/list/by-ids',
                  method: 'post',
                  data: uniqueParkIds,
                  timeout: 30000
                })
                const parkingList = (parkingRes && parkingRes.data) || []
                if (parkingList.length > 0) {
                  // 如果有多个停车场，取第一个或合并名称
                  if (parkingList.length === 1) {
                    parkingName = parkingList[0].parkingName || parkingList[0].name || ''
                  } else {
                    parkingName = parkingList.map(p => p.parkingName || p.name).filter(Boolean).join('、') || ''
                  }
                }
              } catch (parkingError) {
                console.warn('获取停车场信息失败:', parkingError)
                parkingName = ''
              }
            }
            
            // 构建 currentQRCodeRecord 对象
            this.currentQRCodeRecord = {
              couponId: couponId,
              businessId: businessId,
              couponName: couponDetail.couponName || selectedCoupon.couponName || '',
              couponType: couponDetail.couponType || selectedCoupon.couponType || '',
              merchantName: merchantName,
              parkingName: parkingName,
              couponPriceYuan: couponDetail.couponPriceYuan,
              couponDiscountRatePercent: couponDetail.couponDiscountRatePercent,
              couponFreeMinutes: couponDetail.couponFreeMinutes
            }
            
            // 合成图片
            await this.mergeQRCodeWithInfo()
          } catch (detailError) {
            console.warn('获取优惠券详情或合成图片失败:', detailError)
            // 即使失败也继续显示二维码
            this.mergedQrCodeImageUrl = ''
          }
          
          this.qrVisible = true
          // 启动时间更新定时器
          this.startTimeUpdateTimer()
          // 如果是动态二维码，启动刷新定时任务
          if (!isStaticQrCode) {
            this.startQRCodeRefreshTimer()
          }
        } catch (error) {
          console.error('生成二维码失败:', error)
          alert('生成二维码失败')
        }
      } catch (e) {
        alert('获取商户信息失败，无法生成二维码')
      }
    },
    async updateQRCode () {
      // 更新二维码：调用 rotate 接口旋转版本号，使旧二维码失效
      if (!this.currentQRCodeCouponId || !this.currentQRCodeBusinessId) {
        alert('二维码信息缺失，无法更新')
        return
      }
      try {
        // 获取商户信息
        let userId = localStorage.getItem('userId')
        if (!userId) {
          const tokenObj = localStorage.getItem('token')
          if (tokenObj) {
            try {
              const parts = tokenObj.split('.')
              if (parts.length === 3) {
                const payload = JSON.parse(atob(parts[1]))
                userId = payload.userId || payload.uid || payload.sub || null
              }
            } catch (e) { /* ignore */ }
          }
        }
        // 获取商户信息，判断是否是动态二维码
        let isStaticQrCode = true // 默认为静态二维码
        try {
          const businessDetail = await getMyBusinessDetail(this.currentQRCodeBusinessId)
          isStaticQrCode = businessDetail?.data?.isStaticQrCode !== false // 默认为true，只有明确为false时才设为false
        } catch (e) {
          console.warn('获取商户详情失败，使用默认值（静态二维码）:', e)
        }

        // 构建链接：使用新的URL格式，参数为 bid={businessId} 和 cid={couponId}
        // 如果是动态二维码，需要添加 code 参数
        // 根据环境变量获取业务端URL
        const env = process.env.VUE_APP_ENV || process.env.NODE_ENV || 'development'
        let businessBaseUrl
        if (env === 'production') {
          businessBaseUrl = 'https://business.xihuiting.com'
        } else if (env === 'staging') {
          businessBaseUrl = 'https://testbusiness.xihuiting.com'
        } else {
          // 开发环境：使用 localhost
          const businessHost = process.env.VUE_APP_BUSINESS_HOST || 'localhost'
          const businessPort = process.env.VUE_APP_BUSINESS_PORT || '8019'
          businessBaseUrl = `http://${businessHost}:${businessPort}`
        }
        const base = `${businessBaseUrl}/#/coupon/qr`
        const couponId = this.currentQRCodeCouponId
        const businessId = this.currentQRCodeBusinessId
        let link = `${base}?bid=${encodeURIComponent(this.currentQRCodeBusinessId)}&cid=${encodeURIComponent(this.currentQRCodeCouponId)}`

        // 判断是否是动态二维码（非静态二维码）
        if (isStaticQrCode) {
          // 静态二维码：更新时调用 rotate 获取新版本号并更新到数据库
          const versionCacheKey = `${couponId}_${businessId}`
          if (this.qrVersionCache[versionCacheKey]) {
            delete this.qrVersionCache[versionCacheKey]
          }
          let version = ''
          try {
            const rotateResp = await rotateCouponQr(businessId, couponId)
            // 兼容多种返回结构
            const resp = rotateResp || {}
            const d = resp.data
            version = (
              (d && d.version) ||
              (d && d.data && d.data.version) ||
              (d && typeof d === 'string' && d) ||
              (resp.version) ||
              (resp.result && resp.result.version) ||
              ''
            )
            // 更新时获取的新版本号需要缓存，确保之后生成的二维码使用新版本号
            if (version) {
              this.qrVersionCache[versionCacheKey] = version
              console.log('二维码版本号已更新到数据库:', version)
            } else {
              // 如果获取版本号失败，抛出异常
              throw new Error('无法获取新的二维码版本号')
            }
          } catch (e) {
            // 更新版本号失败，抛出异常让调用方处理
            console.error('旋转二维码版本失败:', e)
            throw new Error('更新二维码版本号失败：' + (e.message || '未知错误'))
          }
          
          if (version) {
            link += `&version=${encodeURIComponent(version)}`
          }
        } else {
          // 动态二维码：更新时使旧code失效并生成新的code（不处理版本号）
          // 动态二维码：更新时使旧code失效并生成新的code
          try {
            // 从当前二维码URL中提取旧的code（如果有）
            const oldCodeMatch = this.qrLink?.match(/[?&]code=([^&]+)/)
            const oldCode = oldCodeMatch ? decodeURIComponent(oldCodeMatch[1]) : null
            
            // 如果有旧code，调用 invalidateCouponCode 使旧code失效并生成新的
            // 如果没有旧code，直接调用 refreshCouponCode 生成新的
            let codeResp
            if (oldCode) {
              codeResp = await invalidateCouponCode(this.currentQRCodeBusinessId, this.currentQRCodeCouponId, oldCode)
            } else {
              codeResp = await refreshCouponCode(this.currentQRCodeBusinessId, this.currentQRCodeCouponId)
            }
            
            const code = codeResp?.data?.code || codeResp?.code
            if (code) {
              link += `&code=${encodeURIComponent(code)}`
              console.log('动态二维码已更新code参数: code=', code)
            } else {
              console.warn('获取动态二维码code失败，将生成不带code的二维码')
            }
          } catch (e) {
            console.error('更新动态二维码code失败:', e)
            // 即使获取code失败，也继续生成二维码（不带code参数）
          }
        }
        
        // 重新合成图片（如果有currentQRCodeRecord）
        if (this.currentQRCodeRecord && Object.keys(this.currentQRCodeRecord).length > 0) {
          try {
            await this.mergeQRCodeWithInfo()
          } catch (mergeError) {
            console.warn('重新合成图片失败:', mergeError)
          }
        }

        this.qrLink = link
        // 使用 qrcode.js 本地生成二维码
        try {
          this.qrImgUrl = await QRCode.toDataURL(link, {
            width: 300,
            margin: 1,
            color: {
              dark: '#000000',
              light: '#FFFFFF'
            }
          })
          // 更新成功提示
          alert('二维码已更新')
        } catch (error) {
          console.error('生成二维码失败:', error)
          alert('更新二维码失败')
        }
      } catch (e) {
        // 错误已在 rotate 调用时处理，这里只做兜底
        console.error('更新二维码失败:', e)
        if (!e.message || !e.message.includes('更新二维码版本号失败')) {
          alert('更新二维码失败：' + (e.message || '未知错误'))
        }
      }
    },
    // 更新二维码（重新生成，更新版本号）
    async handleUpdateQRCode () {
      if (!this.currentQRCodeCouponId || !this.currentQRCodeBusinessId) {
        console.warn('二维码信息缺失，无法更新')
        alert('二维码信息缺失，无法更新')
        return
      }
      
      const couponId = this.currentQRCodeCouponId
      const businessId = this.currentQRCodeBusinessId
      
      // 只对静态二维码进行更新操作
      if (!this.isStaticQrCode) {
        console.warn('动态二维码不支持更新操作，请使用刷新功能')
        alert('动态二维码不支持更新操作，请使用刷新功能')
        return
      }
      
      try {
        // 获取当前版本号
        const versionCacheKey = `${couponId}_${businessId}`
        let currentVersion = this.qrVersionCache[versionCacheKey]
        
        // 如果缓存中没有，从URL中提取或从后端获取
        if (!currentVersion) {
          const versionMatch = this.qrLink?.match(/[?&]version=([^&]+)/)
          if (versionMatch) {
            currentVersion = decodeURIComponent(versionMatch[1])
          } else {
            // 从后端获取当前版本号
            try {
              const currentVersionResp = await getCurrentQrVersion(businessId, couponId)
              const resp = currentVersionResp || {}
              const d = resp.data
              currentVersion = (
                (resp.version) ||
                (d && d.version) ||
                (d && d.data && d.data.version) ||
                (d && typeof d === 'string' && d) ||
                (resp.result && resp.result.version) ||
                ''
              )
              if (currentVersion) {
                this.qrVersionCache[versionCacheKey] = currentVersion
              }
            } catch (e) {
              console.error('获取当前版本号失败:', e)
              alert('获取当前版本号失败，请稍后重试')
              return
            }
          }
        }
        
        // 显示确认弹窗
        this.currentVersionForUpdate = currentVersion || ''
        this.inputVersionForUpdate = ''
        this.updateVersionModalVisible = true
      } catch (error) {
        console.error('准备更新二维码失败:', error)
        alert('准备更新二维码失败：' + (error.message || '未知错误'))
      }
    },
    // 关闭更新版本号确认弹窗
    closeUpdateVersionModal () {
      this.updateVersionModalVisible = false
      this.currentVersionForUpdate = ''
      this.inputVersionForUpdate = ''
    },
    // 确认更新二维码
    async confirmUpdateQRCode () {
      // 验证用户输入的版本号
      const inputVersion = (this.inputVersionForUpdate || '').trim()
      const currentVersion = (this.currentVersionForUpdate || '').trim()
      
      if (!inputVersion) {
        alert('请输入当前版本号')
        return
      }
      
      if (inputVersion !== currentVersion) {
        alert('输入的版本号与当前版本号不一致，请重新输入')
        return
      }
      
      if (!this.currentQRCodeCouponId || !this.currentQRCodeBusinessId) {
        alert('二维码信息缺失，无法更新')
        this.closeUpdateVersionModal()
        return
      }
      
      const couponId = this.currentQRCodeCouponId
      const businessId = this.currentQRCodeBusinessId
      
      this.isUpdatingQRCode = true
      
      try {
        const versionCacheKey = `${couponId}_${businessId}`
        
        // 记录旧版本号（如果存在），旧版本号将在更新后立即失效
        const oldVersion = currentVersion
        if (oldVersion) {
          console.log('准备更新二维码版本号，旧版本号将失效:', oldVersion)
        }
        
        // 清除版本号缓存，强制获取新版本号
        if (this.qrVersionCache[versionCacheKey]) {
          delete this.qrVersionCache[versionCacheKey]
          console.log('已清除版本号缓存:', versionCacheKey)
        }
        
        // 调用 rotate 接口获取新版本号并更新到数据库
        // rotate 操作会生成新版本号，旧的版本号将立即失效
        const rotateResp = await rotateCouponQr(businessId, couponId)
        // 兼容多种返回结构（request工具返回的是response.data）
        const resp = rotateResp || {}
        const d = resp.data
        const version = (
          (resp.version) ||
          (d && d.version) ||
          (d && d.data && d.data.version) ||
          (d && typeof d === 'string' && d) ||
          (resp.result && resp.result.version) ||
          ''
        )
        
        // 更新时获取的新版本号需要缓存，确保之后生成的二维码使用新版本号
        if (version) {
          this.qrVersionCache[versionCacheKey] = version
          if (oldVersion) {
            console.log('二维码版本号已更新，旧版本号已失效:', { oldVersion, newVersion: version })
          } else {
            console.log('二维码版本号已更新到数据库:', version)
          }
        } else {
          throw new Error('无法获取新的二维码版本号')
        }
        
        // 重新生成二维码URL和图片
        // 根据环境变量获取业务端URL
        const env = process.env.VUE_APP_ENV || process.env.NODE_ENV || 'development'
        let businessBaseUrl
        if (env === 'production') {
          businessBaseUrl = 'https://business.xihuiting.com'
        } else if (env === 'staging') {
          businessBaseUrl = 'https://testbusiness.xihuiting.com'
        } else {
          // 开发环境：使用 localhost
          const businessHost = process.env.VUE_APP_BUSINESS_HOST || 'localhost'
          const businessPort = process.env.VUE_APP_BUSINESS_PORT || '8019'
          businessBaseUrl = `http://${businessHost}:${businessPort}`
        }
        const base = `${businessBaseUrl}/#/coupon/qr`
        const link = `${base}?bid=${encodeURIComponent(businessId)}&cid=${encodeURIComponent(couponId)}&version=${encodeURIComponent(version)}`
        
        // 更新二维码链接
        this.qrLink = link
        
        // 重新生成二维码图片
        this.qrImgUrl = await QRCode.toDataURL(link, {
          width: 300,
          margin: 1,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        })
        
        // 重新合成图片（如果有currentQRCodeRecord）
        if (this.currentQRCodeRecord && Object.keys(this.currentQRCodeRecord).length > 0) {
          try {
            await this.mergeQRCodeWithInfo()
          } catch (mergeError) {
            console.warn('重新合成图片失败:', mergeError)
          }
        }
        
        console.log('二维码已更新，新版本号:', version, '新链接:', link)
        alert('二维码已更新成功')
        
        // 关闭弹窗
        this.closeUpdateVersionModal()
      } catch (error) {
        console.error('更新二维码失败:', error)
        alert('更新二维码失败：' + (error.message || '未知错误'))
      } finally {
        this.isUpdatingQRCode = false
      }
    },
    async issue () {
      // 1. 验证车牌号
      if (!this.plate || !this.plate.trim()) {
        alert('请输入车牌号')
        return
      }

      // 2. 验证是否选择了优惠券
      if (this.selected === null || this.selected === undefined) {
        alert('请先选择一个优惠券')
        return
      }

      // 3. 获取当前选中的优惠券原始数据
      const selectedCoupon = this.rawList[this.selected]
      if (!selectedCoupon) {
        alert('未找到选中的优惠券信息')
        return
      }

      // 4. 获取优惠券ID和商户ID
      const couponId = selectedCoupon.couponId || selectedCoupon.id
      if (!couponId) {
        alert('优惠券ID不存在，无法发放')
        return
      }

      // 5. 检查是否为模拟数据模式
      if (!this.useRealAPI || couponId.startsWith('mock-')) {
        alert('当前为模拟数据模式，无法真正发放优惠券')
        return
      }

      // 6. 获取商户businessId（从商户列表中获取）
      let businessId = null
      try {
        // 不调用接口获取用户信息：优先本地 userId，缺失再从 token 解析
        let userId = localStorage.getItem('userId')
        if (!userId) {
            const token = localStorage.getItem('token')
            if (token) {
              try {
                const parts = token.split('.')
                if (parts.length === 3) {
                  const payload = JSON.parse(atob(parts[1]))
                userId = payload.userId || payload.uid || payload.sub || null
              }
            } catch (e) { /* ignore */ }
          }
        }
        if (!userId) {
          alert('未找到用户ID，无法发放优惠券')
          return
        }

        // 根据用户ID查询该用户作为管理员的商户
        const merchantRes = await request({
          url: '/market/business/list',
          method: 'post',
          data: { administor: userId },
          timeout: 30000
        })

        const merchantList = merchantRes?.data || []
        if (merchantList.length === 0) {
          alert('未找到商户信息，无法发放优惠券')
          return
        }

        // 如果只有一个商户，直接使用；如果有多个，使用第一个（或者根据当前选中的停车场/道路匹配）
        const merchant = merchantList[0]
        businessId = merchant.businessId

        if (!businessId) {
          alert('商户ID不存在，无法发放优惠券')
          return
        }

        console.log('=== 发放优惠券参数 ===')
        console.log('车牌号:', this.plate.trim())
        console.log('商户ID:', businessId)
        console.log('优惠券ID:', couponId)
        console.log('==================')

        // 7. 先检查车牌号是否在场内
        const parkIds = selectedCoupon.parkIds || []
        if (!parkIds || parkIds.length === 0) {
          alert('优惠券未关联停车场，无法发放')
          return
        }

        // 查询车牌号是否在任何一个关联的停车场内
        let isInParking = false
        const plateNumber = this.plate.trim()
        
        for (const parkingId of parkIds) {
          try {
            const orderUrl = process.env.NODE_ENV === 'development'
              ? 'http://localhost:8086/order/parking-record/in-order/search'
              : '/order/parking-record/in-order/search'
            
            const inOrderResponse = await request({
              url: orderUrl,
              method: 'post',
              params: { page: 1, size: 10 },
              data: {
                parkingId: parkingId,
                plateNo: plateNumber,
                plateNumber: plateNumber
              },
              timeout: 30000
            })
            
            const inOrderList = inOrderResponse?.data?.data || inOrderResponse?.data?.records || inOrderResponse?.data || []
            if (inOrderList && inOrderList.length > 0) {
              isInParking = true
              break
            }
          } catch (checkError) {
            console.error(`检查停车场 ${parkingId} 的在场订单失败:`, checkError)
            // 继续检查下一个停车场
          }
        }

        if (!isInParking) {
          alert('车辆不在场内，无需领取优惠券')
          return
        }

        // 8. 在发放前先检查余额是否足够
        this.loading = true
        try {
          // 尝试检查余额，如果检查失败，继续尝试发放（让后端处理）
          try {
            const [couponDetail, businessDetail] = await Promise.all([
              getCouponDetail(couponId),
              getMyBusinessDetail(businessId)
            ])

            // 获取商家支付单价（元）
            const businessPayment = couponDetail?.data?.businessPayment || 0
            if (businessPayment > 0) {
              // 获取商户余额信息
              const walletBalance = businessDetail?.data?.walletBalance || 0
              const giftedAmount = businessDetail?.data?.giftedAmount || 0
              const isSupportOverdraft = businessDetail?.data?.isSupportOverdraft || false
              const overdraftQuota = businessDetail?.data?.overdraftQuota || 0

              // 计算可用余额（包括透支额度）
              let availableWalletBalance = walletBalance
              if (isSupportOverdraft) {
                availableWalletBalance = walletBalance + overdraftQuota
              }

              // 计算总可用余额（储值账户 + 赠送账户）
              const totalAvailableBalance = availableWalletBalance + giftedAmount

              // 检查余额是否足够
              if (totalAvailableBalance < businessPayment) {
                this.loading = false
                // 商家端显示简化的提示
                alert('余额不足')
                return
              }
            }
          } catch (checkError) {
            // 余额检查失败，记录日志但不阻止发放（让后端处理）
            console.warn('余额检查失败，继续尝试发放:', checkError)
          }

          // 余额足够或检查失败，执行发放
          // 注意：创建发放记录的逻辑已整合到后端发放接口中，无需前端单独调用
          await dispatchCoupon(this.plate.trim(), businessId, couponId)
          console.log('发放优惠券成功')

          alert(`优惠券已成功发放给车牌 ${this.plate.trim()}`)

          this.plate = ''
        } catch (error) {
          console.error('发放优惠券失败:', error)
          // 提取错误信息
          let errorMessage = '发放失败'
          if (error.response && error.response.data) {
            const errorData = error.response.data
            if (errorData.message) {
              errorMessage = errorData.message
            } else if (errorData.error) {
              errorMessage = errorData.error
            } else if (typeof errorData === 'string') {
              errorMessage = errorData
            }
          } else if (error.message) {
            errorMessage = error.message
          }

          // 检查是否是余额不足的错误
          if (errorMessage.includes('余额不足') || errorMessage.includes('不足以抵扣') || errorMessage.includes('无法发放优惠券')) {
            // 商家端显示简化的提示
            alert('余额不足')
          } else {
            alert(`发放优惠券失败: ${errorMessage}`)
          }
        } finally {
          this.loading = false
        }
      } catch (error) {
        console.error('获取商户信息失败:', error)
        alert('获取商户信息失败，请稍后重试')
        this.loading = false
      }
    },
    async fetchScopeOptions () {
      this.loading = true
      
      try {
        // 优先从 localStorage 读取 userId，必要时从 token 解析
        // token 优先从 Vuex store 获取，如果没有则从 localStorage 获取
        let userId = localStorage.getItem('userId')
        if (!userId) {
          const storeToken = this.$store.getters.token
          const localStorageToken = localStorage.getItem('token')
          const token = storeToken || localStorageToken
          if (token) {
            try {
              const parts = token.split('.')
              if (parts.length === 3) {
                const payload = JSON.parse(atob(parts[1]))
                userId = payload.userId || payload.uid || payload.sub || null
                // 如果解析到 userId，缓存到 localStorage
                if (userId) {
                  localStorage.setItem('userId', String(userId))
                }
              }
            } catch (e) { /* ignore */ }
          }
        }
        if (!userId) {
          console.warn('未能从本地获取userId，无法查询商户列表')
          this.loading = false
          return
        }

        // 根据用户ID查询该用户作为管理员的商户
        let merchantList = []
        if (userId) {
          try {
            const merchantRes = await request({
              url: '/market/business/list',
              method: 'post',
              data: { administor: userId },
              timeout: 30000
            })
            merchantList = merchantRes?.data || []
            // 保存到本地状态，默认使用第一个商户ID
            this.merchants = merchantList
            this.currentBusinessId = (merchantList && merchantList[0] && merchantList[0].businessId) || null
            // 保存第一个商户的"是否允许自定义创建优惠券"字段
            this.isAllowCustomCoupon = (merchantList && merchantList[0] && merchantList[0].isAllowCustomCoupon) || false
            console.log('查询到商户列表:', merchantList)
            console.log('是否允许自定义创建优惠券:', this.isAllowCustomCoupon)
          } catch (merchantError) {
            console.warn('查询商户列表失败:', merchantError)
            // 如果是401或403错误，可能是token问题，提示用户重新登录
            if (merchantError?.response?.status === 401 || merchantError?.response?.status === 403) {
              console.warn('API访问被拒绝(401/403)，可能是token无效')
              this.clearUserToken()
              alert('登录已过期，请重新登录')
              this.$router.push('/login')
              this.loading = false
              return
            }
            // 如果查询商户列表失败，保留原有选项，不更新
            this.loading = false
            return
          }
        } else {
          // 如果没有用户ID，保留原有选项，不更新
          console.warn('未获取到用户ID，无法查询商户列表')
          this.loading = false
          return
        }

        // 获取所有商户的停车场ID和道路ID
          const allParkIds = []
        const allRoadIds = []
          merchantList.forEach(merchant => {
            if (merchant.parkIds && Array.isArray(merchant.parkIds)) {
              allParkIds.push(...merchant.parkIds)
            }
          if (merchant.roadIds && Array.isArray(merchant.roadIds)) {
            allRoadIds.push(...merchant.roadIds)
          }
          })
          
          console.log('商户关联的停车场ID列表:', allParkIds)
        console.log('商户关联的道路ID列表:', allRoadIds)
          
        // 使用后端批量查询接口，根据商户关联的ID列表查询（筛选逻辑在后端）
        let parkingList = []
          if (allParkIds.length > 0) {
            try {
            // 去重
            const uniqueParkIds = [...new Set(allParkIds)]
              const parkingRes = await request({ 
              url: '/parking/info/list/by-ids', 
                method: 'post', 
              data: uniqueParkIds,
                timeout: 30000
              })
            parkingList = (parkingRes && parkingRes.data) || []
            console.log('根据ID列表查询到停车场:', parkingList.length)
            } catch (parkingError) {
              console.warn('查询停车场失败:', parkingError)
              // 如果是401或403错误，可能是token问题
              if (parkingError?.response?.status === 401 || parkingError?.response?.status === 403) {
                console.warn('查询停车场API访问被拒绝(401/403)，可能是token无效')
                // 不在这里处理，让外层统一处理
              }
            }
        } else {
          // 如果没有商户关联的停车场ID，不查询所有停车场，返回空列表
          console.log('没有商户关联的停车场ID，返回空列表')
          parkingList = []
        }
        
        // 使用后端批量查询接口，根据商户关联的道路ID列表查询
        let roadList = []
        if (allRoadIds.length > 0) {
          try {
            // 去重
            const uniqueRoadIds = [...new Set(allRoadIds)]
            const roadRes = await request({ 
              url: '/road/list/by-ids', 
              method: 'post', 
              data: uniqueRoadIds,
              timeout: 30000
            })
            roadList = (roadRes && roadRes.data) || []
            console.log('根据ID列表查询到道路:', roadList.length)
          } catch (roadError) {
            console.warn('查询道路失败:', roadError)
            // 如果是401或403错误，可能是token问题
            if (roadError?.response?.status === 401 || roadError?.response?.status === 403) {
              console.warn('查询道路API访问被拒绝(401/403)，可能是token无效')
              // 不在这里处理，让外层统一处理
            }
          }
        } else {
          // 如果没有商户关联的道路ID，不查询，返回空列表
          console.log('没有商户关联的道路ID，返回空列表')
          roadList = []
        }

        const parkingOptions = parkingList.map(p => ({
          type: 'parking',
          value: p.parkingId || p.id || p.parkingCode,
          label: [p.parkingName, p.parkingAddress].filter(Boolean).join(' - '),
          meta: p
        }))
        const roadOptions = roadList.map(r => ({
          type: 'road',
          value: r.roadId || r.id,
          label: [r.roadName, r.roadAddress].filter(Boolean).join(' - ')
        }))

        // 成功获取数据后，更新选项列表
        this.options = [...parkingOptions, ...roadOptions]
        
        // 如果获取到新的选项，清空当前选择以便重新选择
        if (this.options.length > 0) {
          // 只有当有新的选项时才清空当前选择
          this.currentSelectedOption = null
          this.selectedLabel = ''
          this.searchKeyword = ''
        }
        
        // 默认选中首个选项（优先停车场，其次道路）
        // selectOption 会自动调用 loadCoupons，所以这里不需要再手动调用
        if (parkingOptions.length > 0) {
          this.selectOption(parkingOptions[0])
        } else if (roadOptions.length > 0) {
          this.selectOption(roadOptions[0])
        } else if (this.currentBusinessId) {
          // 如果没有停车场和道路选项，但有商户ID，则直接加载优惠券
          await this.loadCoupons()
        }
        
        console.log('成功加载选项:', { 
          merchantCount: merchantList.length,
          parkingCount: parkingList.length, 
          roadCount: roadList.length,
          totalOptions: this.options.length
        })
      } catch (e) {
        console.error('加载选项失败:', e)
        // 如果是401或403错误，可能是token问题，提示用户重新登录
        if (e?.response?.status === 401 || e?.response?.status === 403) {
          console.warn('加载选项API访问被拒绝(401/403)，可能是token无效')
          this.clearUserToken()
          alert('登录已过期，请重新登录')
          this.$router.push('/login')
          this.loading = false
          return
        }
        // 发生其他错误时，保留原有选项，不更新
        // 这样可以避免在页面切换时因为临时错误而显示"无匹配结果"
      } finally {
        this.loading = false
      }
    },
    toggleDropdown (e) {
      // 仅在点击容器时切换，点击内部控件由各自事件控制
      if (e && (e.target && (e.target.tagName === 'INPUT' || e.target.classList.contains('clear-btn')))) return
      this.showDropdown = !this.showDropdown
      if (this.showDropdown) this.$nextTick(() => this.$refs.lotSearchInput && this.$refs.lotSearchInput.focus())
    },
    openDropdown () {
      this.showDropdown = true
    },
    handleOutsideClick (evt) {
      const root = this.$el.querySelector('.select-lot')
      if (root && !root.contains(evt.target)) {
        this.showDropdown = false
      }
    },
    onSearchInput () {
      // 即时过滤由 computed 处理，这里保持方法存在以便未来扩展
      return undefined
    },
    clearSearch () {
      this.searchKeyword = ''
    },
    selectOption (opt) {
      this.selectedLabel = opt.label
      this.currentSelectedOption = opt
      this.showDropdown = false
      this.searchKeyword = ''
      // 选择后重新加载优惠券
      this.couponPageNo = 1
      this.couponTotal = 0
      this.couponHasMore = false
      this.list = []
      this.rawList = []
      this.loadCoupons({ pageNo: 1, append: false })
    },
    clearSelection () {
      this.selectedLabel = ''
      this.currentSelectedOption = null
      this.searchKeyword = ''
      // 清除选择后按商户范围重新加载优惠券
      this.couponPageNo = 1
      this.couponTotal = 0
      this.couponHasMore = false
      this.list = []
      this.rawList = []
      this.loadCoupons({ pageNo: 1, append: false })
    },
    // 打开车牌输入键盘
    openPlateKeyboard () {
      this.plateKeyboardVisible = true
    },
    // 关闭车牌输入键盘
    closePlateKeyboard () {
      this.plateKeyboardVisible = false
    },
    // 处理车牌键盘输入
    handlePlateKeyboardInput (value) {
      this.plate = value
    },
    // 跳转到创建页面，传递当前选中的停车场信息
    goToCreate () {
      if (!this.currentSelectedOption) {
        alert('请先选择一个停车场或道路')
        return
      }
      // 传递当前选中的停车场/道路信息
      const query = {
        type: this.currentSelectedOption.type,
        value: this.currentSelectedOption.value,
        label: this.currentSelectedOption.label
      }
      // 如果有完整的停车场信息，也传递
      if (this.currentSelectedOption.meta) {
        query.parkingId = this.currentSelectedOption.meta.parkingId || this.currentSelectedOption.meta.id || this.currentSelectedOption.meta.parkingCode
        query.parkingName = this.currentSelectedOption.meta.parkingName || this.currentSelectedOption.meta.name
        query.parkingAddress = this.currentSelectedOption.meta.parkingAddress || this.currentSelectedOption.meta.address
      }
      this.$router.push({
        path: '/coupon/create2',
        query: query
      })
    },
    // 格式化优惠券类型文本（用于显示）
    formatCouponTypeText (couponType) {
      if (!couponType) return '优惠券'
      const type = (couponType || '').toString().toUpperCase()
      if (type === 'CASH' || type === 'AMOUNT' || type === 'MONEY') {
        return '金额券'
      } else if (type === 'PERCENT' || type === 'DISCOUNT') {
        return '折扣券'
      } else if (type === 'TIME' || type === 'DURATION') {
        return '时长券'
      } else if (type === 'FREE') {
        return '全免券'
      }
      return '优惠券'
    },
    // 格式化时间为 yyyy-mm-dd hh:mm:ss
    formatTime (date) {
      const d = date || new Date()
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hours = String(d.getHours()).padStart(2, '0')
      const minutes = String(d.getMinutes()).padStart(2, '0')
      const seconds = String(d.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    // 启动时间更新定时器（每秒更新）
    startTimeUpdateTimer () {
      this.stopTimeUpdateTimer()
      this.currentTime = this.formatTime()
      this.timeUpdateTimer = setInterval(() => {
        this.currentTime = this.formatTime()
      }, 1000)
    },
    // 停止时间更新定时器
    stopTimeUpdateTimer () {
      if (this.timeUpdateTimer) {
        clearInterval(this.timeUpdateTimer)
        this.timeUpdateTimer = null
      }
    },
    // 启动二维码刷新定时任务（每3秒刷新 code）
    startQRCodeRefreshTimer () {
      this.stopQRCodeRefreshTimer()
      this.refreshProgress = 0
      // 进度条动画：3秒内从0到100
      const progressInterval = setInterval(() => {
        this.refreshProgress += 100 / 30 // 每100ms增加约3.33%
        if (this.refreshProgress >= 100) {
          this.refreshProgress = 100
        }
      }, 100)
      
      // 每3秒刷新一次 code
      this.qrRefreshTimer = setInterval(async () => {
        this.refreshProgress = 0
        await this.refreshQRCode()
      }, 3000)
      
      // 保存进度条定时器，用于清理
      this.progressInterval = progressInterval
    },
    // 停止二维码刷新定时任务
    stopQRCodeRefreshTimer () {
      if (this.qrRefreshTimer) {
        clearInterval(this.qrRefreshTimer)
        this.qrRefreshTimer = null
      }
      if (this.progressInterval) {
        clearInterval(this.progressInterval)
        this.progressInterval = null
      }
      this.refreshProgress = 0
    },
    // 刷新二维码 code（如果 code 有变化，重新生成二维码）
    async refreshQRCode () {
      if (!this.currentQRCodeBusinessId || !this.currentQRCodeCouponId || this.isStaticQrCode || this.isQRCodeGrayed) {
        return
      }
      
      try {
        const codeResp = await refreshCouponCode(this.currentQRCodeBusinessId, this.currentQRCodeCouponId, this.currentQRCode)
        const newCode = codeResp?.data?.code || codeResp?.code
        
        if (newCode && newCode !== this.currentQRCode) {
          // code 有变化，重新生成二维码，重置计数器，恢复显示
          console.log('检测到 code 变化，重新生成二维码:', { oldCode: this.currentQRCode, newCode, refreshCount: this.refreshCount })
          this.currentQRCode = newCode
          this.refreshCount = 0 // 重置计数器，重新开始计算100次
          
          // 如果二维码之前被灰化，恢复显示
          if (this.isQRCodeGrayed) {
            console.log('code 有变化，恢复二维码显示并重新启动定时刷新')
            this.isQRCodeGrayed = false
            // 如果定时器已停止，重新启动
            if (!this.qrRefreshTimer) {
              this.startQRCodeRefreshTimer()
            }
          }
          
          // 重新构建链接
          const env = process.env.VUE_APP_ENV || process.env.NODE_ENV || 'development'
          let businessBaseUrl
          if (env === 'production') {
            businessBaseUrl = 'https://business.xihuiting.com'
          } else if (env === 'staging') {
            businessBaseUrl = 'https://testbusiness.xihuiting.com'
          } else {
            // 开发环境：使用 localhost
            const businessHost = process.env.VUE_APP_BUSINESS_HOST || 'localhost'
            const businessPort = process.env.VUE_APP_BUSINESS_PORT || '8019'
            businessBaseUrl = `http://${businessHost}:${businessPort}`
          }
          const base = `${businessBaseUrl}/#/coupon/qr`
          // 获取版本号（从缓存中获取，不需要重新获取）
          const versionCacheKey = `${this.currentQRCodeCouponId}_${this.currentQRCodeBusinessId}`
          const version = this.qrVersionCache[versionCacheKey] || ''
          let link = `${base}?bid=${encodeURIComponent(this.currentQRCodeBusinessId)}&cid=${encodeURIComponent(this.currentQRCodeCouponId)}&code=${encodeURIComponent(newCode)}`
          if (version) {
            link += `&version=${encodeURIComponent(version)}`
          }
          
          // 重新生成二维码
          this.qrLink = link
          this.qrImgUrl = await QRCode.toDataURL(link, {
            width: 300,
            margin: 1,
            color: {
              dark: '#000000',
              light: '#FFFFFF'
            }
          })
          // 重新合成图片
          if (this.currentQRCodeRecord && Object.keys(this.currentQRCodeRecord).length > 0) {
            await this.mergeQRCodeWithInfo()
          }
        } else if (newCode) {
          // code 没有变化，增加计数器
          this.refreshCount++
          console.log(`code 未变化，刷新次数: ${this.refreshCount}/100`, newCode)
          
          // 如果刷新100次后code还没变化，停止定时刷新并灰化二维码
          if (this.refreshCount >= 100) {
            console.log('刷新100次后code仍未变化，停止定时刷新并灰化二维码')
            this.stopQRCodeRefreshTimer()
            this.isQRCodeGrayed = true
          }
        }
      } catch (e) {
        console.error('刷新二维码 code 失败:', e)
      }
    },
    // 手动刷新二维码（点击圆形按钮）
    async manualRefreshQRCode () {
      if (this.isRefreshing) {
        console.log('正在刷新中，忽略重复点击')
        return
      }
      this.isRefreshing = true
      console.log('开始手动刷新二维码', {
        isStaticQrCode: this.isStaticQrCode,
        businessId: this.currentQRCodeBusinessId,
        couponId: this.currentQRCodeCouponId,
        currentCode: this.currentQRCode
      })
      
      try {
        // 检查必要参数
        if (!this.currentQRCodeBusinessId || !this.currentQRCodeCouponId) {
          console.error('缺少必要的参数:', {
            businessId: this.currentQRCodeBusinessId,
            couponId: this.currentQRCodeCouponId
          })
          alert('二维码信息缺失，无法刷新')
          throw new Error('缺少必要的参数: businessId 或 couponId')
        }
        
        // 无论静态还是动态二维码，都调用服务端接口强制刷新 code
        console.log('调用服务端接口强制刷新 code', {
          isStaticQrCode: this.isStaticQrCode,
          businessId: this.currentQRCodeBusinessId,
          couponId: this.currentQRCodeCouponId,
          oldCode: this.currentQRCode,
          forceRefresh: true
        })
        
        // 调用服务端接口，传递 forceRefresh=true
        const codeResp = await refreshCouponCode(
          this.currentQRCodeBusinessId, 
          this.currentQRCodeCouponId, 
          this.currentQRCode,
          true // 强制刷新
        )
        
        console.log('服务端返回的响应:', codeResp)
        
        const newCode = codeResp?.data?.code || codeResp?.code
        
        // 重新构建链接
        const env = process.env.VUE_APP_ENV || process.env.NODE_ENV || 'development'
        let businessBaseUrl
        if (env === 'production') {
          businessBaseUrl = 'https://business.xihuiting.com'
        } else if (env === 'staging') {
          businessBaseUrl = 'https://testbusiness.xihuiting.com'
        } else {
          // 开发环境：使用 localhost
          const businessHost = process.env.VUE_APP_BUSINESS_HOST || 'localhost'
          const businessPort = process.env.VUE_APP_BUSINESS_PORT || '8019'
          businessBaseUrl = `http://${businessHost}:${businessPort}`
        }
        const base = `${businessBaseUrl}/#/coupon/qr`
        
        // 构建链接：如果是动态二维码且有新code，添加code参数；否则不添加
        let link = `${base}?bid=${encodeURIComponent(this.currentQRCodeBusinessId)}&cid=${encodeURIComponent(this.currentQRCodeCouponId)}`
        
        if (newCode && !this.isStaticQrCode) {
          // 动态二维码：添加 code 参数
          console.log('强制刷新获取到新的 code:', { oldCode: this.currentQRCode, newCode })
          this.currentQRCode = newCode
          link += `&code=${encodeURIComponent(newCode)}`
        } else if (this.isStaticQrCode) {
          // 静态二维码：不添加 code 参数，但更新 currentQRCode（如果有返回）
          if (newCode) {
            console.log('静态二维码刷新，服务端返回了 code（但不使用）:', newCode)
          }
          this.currentQRCode = ''
        } else {
          // 动态二维码但没有获取到新code
          console.warn('动态二维码刷新失败：未获取到新的 code')
          if (!newCode) {
            alert('刷新失败：未获取到新的验证码')
            return
          }
        }
        
        console.log('重新生成二维码链接:', link)
        
        // 重新生成二维码
        this.qrLink = link
        this.qrImgUrl = await QRCode.toDataURL(link, {
          width: 300,
          margin: 1,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        })
        
        // 重新合成图片
        if (this.currentQRCodeRecord && Object.keys(this.currentQRCodeRecord).length > 0) {
          await this.mergeQRCodeWithInfo()
        }
        
        console.log('二维码重新生成成功')
        
        // 如果是动态二维码，恢复二维码显示、重置计数器、恢复定时刷新
        if (!this.isStaticQrCode) {
          // 恢复二维码显示（如果之前被灰化）
          this.isQRCodeGrayed = false
          // 重置刷新计数器
          this.refreshCount = 0
          // 重置进度条并重新启动进度条动画
          this.refreshProgress = 0
          if (this.progressInterval) {
            clearInterval(this.progressInterval)
          }
          this.progressInterval = setInterval(() => {
            this.refreshProgress += 100 / 30
            if (this.refreshProgress >= 100) {
              this.refreshProgress = 100
            }
          }, 100)
          // 恢复3秒定时刷新（如果之前停止了）
          if (!this.qrRefreshTimer) {
            this.startQRCodeRefreshTimer()
          }
        }
      } catch (e) {
        console.error('手动刷新二维码失败:', e)
        alert('刷新二维码失败: ' + (e.message || '未知错误'))
      } finally {
        // 延迟恢复按钮状态，让旋转动画完成
        setTimeout(() => {
          this.isRefreshing = false
          console.log('手动刷新完成，按钮状态已恢复')
        }, 1000)
      }
    },
    // 合成二维码和优惠券信息为一张图片
    async mergeQRCodeWithInfo () {
      if (!this.qrImgUrl || !this.currentQRCodeRecord) {
        console.warn('合成图片失败：缺少二维码或优惠券信息', {
          hasQrCode: !!this.qrImgUrl,
          hasRecord: !!this.currentQRCodeRecord
        })
        this.mergedQrCodeImageUrl = ''
        return Promise.resolve()
      }

      return new Promise((resolve, reject) => {
        let qrUrl = null
        try {
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')

          // 创建底图图片对象
          const backgroundImg = new Image()
          backgroundImg.crossOrigin = 'anonymous'

          backgroundImg.onload = () => {
            // 设置canvas尺寸为底图尺寸
            canvas.width = backgroundImg.width
            canvas.height = backgroundImg.height

            // 绘制底图
            ctx.drawImage(backgroundImg, 0, 0)

            // 创建二维码图片对象
            const qrImg = new Image()
            qrImg.crossOrigin = 'anonymous'

            qrImg.onload = () => {
              try {
                console.log('二维码图片加载成功，开始绘制合成图片')
                
                // 参考车场二维码的布局方式
                const textX = backgroundImg.width / 2 // 文字居中位置
                const baseFontSize = Math.max(backgroundImg.width, backgroundImg.height) * 0.06 // 基础字体大小
                
                // 文字位置：参考车场二维码的固定百分比位置
                const firstLineY = backgroundImg.height * 0.10 // 第一行：车场名称
                const secondLineY = backgroundImg.height * 0.18 // 第二行：商户名称
                const thirdLineY = backgroundImg.height * 0.23 // 第三行：优惠券名称

                // 设置文字样式：居中对齐，蓝色文字
                ctx.textAlign = 'center'
                ctx.textBaseline = 'middle'
                const maxWidth = backgroundImg.width * 0.85 // 最大文本宽度

                // 第一行：车场名称（字体大一些）
                const parkingName = this.currentQRCodeRecord.parkingName || '-'
                const fontSize1 = Math.floor(baseFontSize * 0.8) // 第一行字体
                ctx.font = `bold ${fontSize1}px Arial, "Microsoft YaHei", sans-serif`
                ctx.fillStyle = '#1890ff'
                let displayParkingName = parkingName
                if (ctx.measureText(parkingName).width > maxWidth) {
                  while (ctx.measureText(displayParkingName + '...').width > maxWidth && displayParkingName.length > 0) {
                    displayParkingName = displayParkingName.slice(0, -1)
                  }
                  displayParkingName += '...'
                }
                ctx.fillText(displayParkingName, textX, firstLineY)

                // 第二行：商户名称（字体小一些）
                const merchantName = this.currentQRCodeRecord.merchantName || '-'
                const fontSize2 = Math.floor(baseFontSize * 0.7) // 第二行字体缩小15%
                ctx.font = `${fontSize2}px Arial, "Microsoft YaHei", sans-serif`
                ctx.fillStyle = '#1890ff'
                let displayMerchantName = merchantName
                if (ctx.measureText(merchantName).width > maxWidth) {
                  while (ctx.measureText(displayMerchantName + '...').width > maxWidth && displayMerchantName.length > 0) {
                    displayMerchantName = displayMerchantName.slice(0, -1)
                  }
                  displayMerchantName += '...'
                }
                ctx.fillText(displayMerchantName, textX, secondLineY)

                // 第三行：优惠券名称（字体小一些）
                const couponName = this.currentQRCodeRecord.couponName || '-'
                const fontSize3 = Math.floor(baseFontSize * 0.7) // 第三行字体缩小15%
                ctx.font = `${fontSize3}px Arial, "Microsoft YaHei", sans-serif`
                ctx.fillStyle = '#1890ff'
                let displayCouponName = couponName
                if (ctx.measureText(couponName).width > maxWidth) {
                  while (ctx.measureText(displayCouponName + '...').width > maxWidth && displayCouponName.length > 0) {
                    displayCouponName = displayCouponName.slice(0, -1)
                  }
                  displayCouponName += '...'
                }
                ctx.fillText(displayCouponName, textX, thirdLineY)

                // 二维码尺寸和位置：参考车场二维码的布局
                const qrSize = Math.min(backgroundImg.width, backgroundImg.height) * 0.66 // 二维码大小为画布的66%
                const qrYPosition = backgroundImg.height * 0.5 - qrSize / 2 // 二维码位置：高度50%处居中
                const qrX = (backgroundImg.width - qrSize) / 2 // 水平居中
                const qrY = qrYPosition

                // 绘制二维码
                ctx.drawImage(qrImg, qrX, qrY, qrSize, qrSize)
                console.log('二维码绘制完成，位置:', { qrX, qrY, qrSize })

                // 释放临时二维码URL
                if (qrUrl) {
                  window.URL.revokeObjectURL(qrUrl)
                }

                // 转换为blob
                canvas.toBlob((blob) => {
                  if (blob) {
                    const url = window.URL.createObjectURL(blob)
                    this.mergedQrCodeImageUrl = url
                    console.log('合成图片生成成功')
                    resolve(url)
                  } else {
                    reject(new Error('合并图片失败'))
                  }
                }, 'image/png')
              } catch (error) {
                console.error('合成图片失败:', error)
                this.mergedQrCodeImageUrl = ''
                if (qrUrl) {
                  window.URL.revokeObjectURL(qrUrl)
                }
                reject(error)
              }
            }

            qrImg.onerror = () => {
              console.error('加载二维码图片失败')
              this.mergedQrCodeImageUrl = ''
              if (qrUrl) {
                window.URL.revokeObjectURL(qrUrl)
              }
              reject(new Error('二维码图片加载失败'))
            }

            // 将二维码DataURL转换为Blob URL
            if (this.qrImgUrl.startsWith('data:')) {
              // 如果是DataURL，先转换为Blob
              fetch(this.qrImgUrl)
                .then(res => res.blob())
                .then(blob => {
                  qrUrl = window.URL.createObjectURL(blob)
                  qrImg.src = qrUrl
                })
                .catch(err => {
                  console.error('转换二维码DataURL失败:', err)
                  reject(new Error('转换二维码DataURL失败'))
                })
            } else {
              qrImg.src = this.qrImgUrl
            }
          }

          backgroundImg.onerror = () => {
            console.error('加载底图失败')
            this.mergedQrCodeImageUrl = ''
            if (qrUrl) {
              window.URL.revokeObjectURL(qrUrl)
            }
            reject(new Error('加载底图失败'))
          }

          // 加载底图（coupon_base.png 在 public 目录下）
          backgroundImg.src = '/coupon_base.png'
          console.log('开始加载底图: /coupon_base.png')
        } catch (error) {
          console.error('合成图片失败:', error)
          this.mergedQrCodeImageUrl = ''
          reject(error)
        }
      })
    },

    // 关闭二维码弹窗
    closeQRCode () {
      this.qrVisible = false
      this.stopQRCodeRefreshTimer()
      this.stopTimeUpdateTimer()
      this.refreshProgress = 0
      this.isRefreshing = false
      // 清空合成图片URL，下次打开时重新生成
      this.mergedQrCodeImageUrl = ''
    }
  }
}
</script>

<style scoped>
.coupon-issue-container {
  width: 100vw;
  max-width: 430px;
  min-height: 100vh;
  background: #fff;
  margin: 0 auto;
  box-sizing: border-box;
  padding-bottom: 70px;
}

.coupon-issue-header {
  font-size: 24px;
  font-weight: bold;
  color: #111;
  margin: 18px 0 0;
  text-align: center;
}

.coupon-issue-desc {
  color: #888;
  font-size: 15px;
  text-align: center;
  margin-bottom: 8px;
}

.select-lot {
  margin-left: auto !important;
  margin-right: auto !important;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  max-width: 360px;
  height: 48px;
  border-radius: 12px;
  border: 1.5px solid #eee;
  background: #fff;
  font-size: 20px;
  color: #888;
  padding: 0 16px;
  outline: none;
  position: relative;
  margin-bottom: 18px;
}

.select-lot .lot-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 18px;
  color: #222;
}

.select-lot .lot-input::placeholder {
  color: #888;
}

.select-lot .caret {
  font-size: 20px;
  color: #bbb;
}

.clear-selection-btn {
  background: transparent;
  border: none;
  color: #999;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  padding: 0 8px;
  margin-right: 4px;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.clear-selection-btn:hover {
  background: #f0f0f0;
  color: #666;
}

.select-lot .dropdown-panel {
  position: absolute;
  top: 52px;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 12px;
  box-shadow: 0 6px 18px #00000014;
  padding: 8px 0 8px 0;
  z-index: 20;
  max-height: 320px;
  overflow: hidden;
}

.dropdown-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  font-size: 14px;
  color: #666;
}

.header-buttons {
  display: flex;
  gap: 8px;
}

.clear-btn {
  background: transparent;
  border: none;
  color: #1890ff;
  font-size: 14px;
  cursor: pointer;
}

.dropdown-list {
  max-height: 260px;
  overflow: auto;
  padding: 4px 8px 8px 8px;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.dropdown-item:hover {
  background: #f7f8fa;
}

.dropdown-item .tag {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 8px;
  color: #fff;
}

.dropdown-item .tag.parking { background: #4ca1ff; }
.dropdown-item .tag.road { background: #09bb07; }

.dropdown-item .label {
  font-size: 15px;
  color: #222;
}

.dropdown-empty, .dropdown-loading {
  text-align: center;
  color: #999;
  padding: 10px 0;
  font-size: 14px;
}

.coupon-issue-tabs {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  background: #fff;
  border-bottom: 1.5px solid #eaeaea;
  position: sticky;
  top: 0;
  z-index: 2;
}

.coupon-issue-tab {
  flex: 1;
  text-align: center;
  font-size: 16px;
  color: #b0b0b0;
  padding: 10px 0 8px;
  cursor: pointer;
  font-weight: 500;
  position: relative;
}

.coupon-issue-tab.active {
  color: #3572e6;
  font-weight: 600;
}

.coupon-issue-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  margin: 18px 0 0;
}

.coupon-empty-tip {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #999;
  text-align: center;
}

.empty-tip-icon {
  font-size: 48px;
  margin-bottom: 16px;
  opacity: 0.6;
}

.empty-tip-text {
  font-size: 18px;
  font-weight: 500;
  color: #666;
  margin-bottom: 8px;
}

.empty-tip-desc {
  font-size: 14px;
  color: #999;
}

.coupon-issue-card {
  width: 44vw;
  max-width: 170px;
  min-width: 120px;
  height: 110px;
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px #e0e0e033;
  cursor: pointer;
}

.coupon-issue-card.selected {
  outline: 3px solid #238aff;
  box-shadow: 0 2px 12px #238aff33;
}

.coupon-issue-card-title {
  font-size: 17px;
  font-weight: bold;
  color: #222;
  margin-bottom: 2px;
}

.coupon-issue-card-value {
  font-size: 18px;
  font-weight: bold;
  color: #3572e6;
}

.coupon-issue-card-date {
  font-size: 12px;
  color: #888;
  margin-top: 2px;
}

.coupon-issue-action-card {
  background: #f7f8fa;
  border-radius: 16px;
  margin: 12px 12px 0;
  padding: 14px 12px 12px;
  box-shadow: 0 2px 8px #e0e0e033;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.coupon-issue-action-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 0;
}

.coupon-issue-action-btn {
  width: 120px;
  height: 36px;
  background: #ff4444;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 18px;
  cursor: pointer;
}

.coupon-issue-action-btn-blue {
  background: #238aff;
}

.coupon-issue-action-input {
  flex: 1;
  height: 36px;
  border-radius: 10px;
  border: none;
  background: #fff;
  padding: 0 10px;
  font-size: 15px;
  color: #222;
  outline: none;
  margin-right: 4px;
  cursor: pointer;
}

.coupon-issue-action-search {
  width: 60px;
  height: 36px;
  background: #238aff;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.2s;
}

.coupon-issue-action-search:hover {
  background: #1a7ae6;
}

/* 加载更多 / 没有更多 */
.load-more-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 12px 0 0;
}
.load-more-btn {
  min-width: 140px;
  height: 36px;
  border: none;
  border-radius: 18px;
  background: transparent;
  color: #3572e6;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: none;
}
.load-more-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.no-more-text {
  color: #999;
  font-size: 13px;
  padding: 6px 0;
}

.qr-modal { 
  position: fixed; 
  left:0; 
  top:0; 
  right:0; 
  bottom:0; 
  background: rgba(0,0,0,.6); 
  backdrop-filter: blur(4px);
  display:flex; 
  align-items:center; 
  justify-content:center; 
  z-index: 999; 
  animation: fadeIn 0.3s ease;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
.qr-dialog { 
  width: 320px; 
  max-height: 90vh;
  overflow-y: auto;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 20px; 
  padding: 20px; 
  text-align:center; 
  position: relative;
  box-shadow: 0 20px 60px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.1) inset;
  animation: slideUp 0.3s ease;
  display: flex;
  flex-direction: column;
}
@keyframes slideUp {
  from { 
    transform: translateY(20px);
    opacity: 0;
  }
  to { 
    transform: translateY(0);
    opacity: 1;
  }
}
.qr-close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  border: none;
  background: rgba(0,0,0,0.1);
  font-size: 28px;
  color: #333;
  cursor: pointer;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  font-weight: 300;
  z-index: 10;
}
.qr-close-btn:hover {
  background: rgba(0,0,0,0.1);
  color: #333;
  transform: rotate(90deg);
}
.qr-image-container {
  background: #fff;
  border-radius: 16px;
  padding: 16px;
  margin: 0 auto 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08), 0 0 0 1px rgba(0,0,0,0.05);
  display: inline-block;
  position: relative;
  flex-shrink: 0;
}
.qr-image-container::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: linear-gradient(135deg, #3572e6, #4d8fff, #70e1f5);
  border-radius: 18px;
  z-index: -1;
  opacity: 0.3;
  filter: blur(8px);
}
.qr-img { 
  width: 250px; 
  height: 250px; 
  display: block; 
  border-radius: 8px;
}
.qr-img.merged-image {
  width: 100%;
  max-width: 280px;
  height: auto;
  max-height: 400px;
  padding: 0;
  border: none;
  background: transparent;
  display: block;
  margin: 0 auto;
}
.qr-image-container.has-merged-image {
  background: transparent;
  padding: 0;
  box-shadow: none;
}
.qr-image-container.has-merged-image::before {
  display: none;
}
.qr-image-grayed .qr-img {
  filter: grayscale(100%) opacity(0.5);
  transition: filter 0.3s ease;
}
.qr-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 250px;
  height: 250px;
  color: #999;
  font-size: 14px;
}
.qr-gray-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
.qr-gray-text {
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  line-height: 1.6;
  padding: 20px;
}
.qr-info {
  margin-bottom: 16px;
  padding: 12px;
  background: rgba(53, 114, 230, 0.05);
  border-radius: 12px;
}
.qr-coupon-type {
  font-size: 17px;
  font-weight: 600;
  color: #3572e6;
  margin-bottom: 8px;
  letter-spacing: 0.5px;
}
.qr-time {
  font-size: 15px;
  color: #666;
  font-family: 'Courier New', 'Monaco', monospace;
  font-weight: 500;
  letter-spacing: 1px;
}
.qr-refresh-progress {
  width: 100%;
  height: 6px;
  background: rgba(0,0,0,0.08);
  border-radius: 3px;
  overflow: hidden;
  margin: 16px 0;
  position: relative;
}
.qr-progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #3572e6, #4d8fff, #70e1f5);
  border-radius: 3px;
  transition: width 0.1s linear;
  box-shadow: 0 0 10px rgba(53, 114, 230, 0.5);
  position: relative;
}
.qr-progress-bar::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
  animation: shimmer 1.5s infinite;
}
@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}
.qr-refresh-button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.qr-refresh-button {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: none;
  background: linear-gradient(135deg, #3572e6, #4d8fff);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(53, 114, 230, 0.4);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.qr-refresh-button::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255,255,255,0.3);
  transform: translate(-50%, -50%);
  transition: width 0.3s ease, height 0.3s ease;
}
.qr-refresh-button:active::before {
  width: 100%;
  height: 100%;
}
.qr-refresh-button:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(53, 114, 230, 0.5);
}
.qr-refresh-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: scale(1);
}
.qr-refresh-button-rotating {
  animation: rotate 1s linear infinite;
}
@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
.qr-refresh-icon {
  width: 24px;
  height: 24px;
  stroke: #fff;
  stroke-width: 2.5;
  fill: none;
  position: relative;
  z-index: 1;
}

.qr-refresh-button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.qr-refresh-button {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: none;
  background: linear-gradient(135deg, #3572e6, #4d8fff);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(53, 114, 230, 0.4);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.qr-refresh-button::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255,255,255,0.3);
  transform: translate(-50%, -50%);
  transition: width 0.3s ease, height 0.3s ease;
}
.qr-refresh-button:active::before {
  width: 100%;
  height: 100%;
}
.qr-refresh-button:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(53, 114, 230, 0.5);
}
.qr-refresh-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: scale(1);
}
.qr-refresh-button-rotating {
  animation: rotate 1s linear infinite;
}
@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
.qr-refresh-icon {
  width: 24px;
  height: 24px;
  stroke: #fff;
  stroke-width: 2.5;
  fill: none;
  position: relative;
  z-index: 1;
}
.qr-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 10px;
  gap: 12px;
  flex-shrink: 0;
  width: 100%;
  min-height: 50px;
}
.qr-update-button-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 40px;
}
.qr-update-button {
  min-width: 120px;
  height: 40px;
  border-radius: 20px;
  border: none;
  background: linear-gradient(135deg, #3572e6, #4d8fff);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-shadow: 0 4px 16px rgba(53, 114, 230, 0.4);
  transition: all 0.3s ease;
  font-size: 15px;
  font-weight: 500;
  padding: 0 20px;
}
.qr-update-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(53, 114, 230, 0.5);
}
.qr-update-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}
.qr-update-button-loading {
  background: linear-gradient(135deg, #9ca3af, #6b7280);
}
.qr-update-icon {
  width: 18px;
  height: 18px;
  animation: none;
}
.qr-update-button-loading .qr-update-icon {
  animation: spin 1s linear infinite;
}
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
.qr-update-loading {
  font-size: 14px;
}
/* 更新版本号确认弹窗样式 */
.update-version-modal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}
.update-version-dialog {
  width: 90%;
  max-width: 400px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 20px;
  padding: 0;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1) inset;
  animation: slideUp 0.3s ease;
  overflow: hidden;
}
.update-version-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}
.update-version-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #222;
}
.update-version-close-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(0, 0, 0, 0.05);
  font-size: 24px;
  color: #666;
  cursor: pointer;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  font-weight: 300;
  padding: 0;
}
.update-version-close-btn:hover {
  background: rgba(0, 0, 0, 0.1);
  transform: rotate(90deg);
}
.update-version-body {
  padding: 24px;
}
.update-version-info {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 12px;
  background: rgba(53, 114, 230, 0.05);
  border-radius: 12px;
}
.version-label {
  font-size: 15px;
  color: #666;
  margin-right: 8px;
  font-weight: 500;
}
.version-value {
  font-size: 16px;
  color: #3572e6;
  font-weight: 600;
  font-family: 'Courier New', 'Monaco', monospace;
  letter-spacing: 1px;
}
.update-version-input-wrapper {
  margin-top: 16px;
}
.update-version-input-label {
  display: block;
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  font-weight: 500;
}
.update-version-input {
  width: 100%;
  height: 44px;
  padding: 0 16px;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  font-size: 16px;
  color: #222;
  background: #fff;
  outline: none;
  transition: all 0.3s ease;
  box-sizing: border-box;
  text-align: center;
  letter-spacing: 2px;
  font-family: 'Courier New', 'Monaco', monospace;
  font-weight: 600;
}
.update-version-input:focus {
  border-color: #3572e6;
  box-shadow: 0 0 0 3px rgba(53, 114, 230, 0.1);
}
.update-version-input::placeholder {
  color: #bbb;
  letter-spacing: 0;
  font-weight: normal;
}
.update-version-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  background: rgba(248, 249, 250, 0.5);
}
.update-version-btn {
  min-width: 100px;
  height: 40px;
  border-radius: 20px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 500;
  transition: all 0.3s ease;
  padding: 0 20px;
}
.update-version-btn-cancel {
  background: #f0f0f0;
  color: #666;
}
.update-version-btn-cancel:hover {
  background: #e0e0e0;
}
.update-version-btn-confirm {
  background: linear-gradient(135deg, #3572e6, #4d8fff);
  color: #fff;
  box-shadow: 0 4px 16px rgba(53, 114, 230, 0.4);
}
.update-version-btn-confirm:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(53, 114, 230, 0.5);
}
.update-version-btn-confirm:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
  background: linear-gradient(135deg, #9ca3af, #6b7280);
}
</style>
